import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import LeftForm from './LeftForm';
import RightForm from './RightForm';

const layout = window.$environment?.CURRENT_LAYOUT;
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));

export default function CompanyEdit(props) {
  const { Styled } = props;
  const i18n = useTranslation();

  return (
    <div className="section-wrapper">
      <SubHeader text={i18n.t('common.mainInformation')} className="subheaderSection companyTitle" variant="h2" />
      <Styled.wrapperSection>
        <LeftForm {...props} />
        <RightForm {...props} />
      </Styled.wrapperSection>
    </div>
  );
}
